import { ClinicianDashboard } from './clinician-dashboard/ClinicianDashboard';

export function Home() {
  return <ClinicianDashboard />;
}
